<template>
    <b-card no-body header="今年運勢分析" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">
        <b-card-body >

            <div v-for="(item , index) in allyear" v-bind:key="index" class="text-center p-0 float-left" style="width: 20%">
                <div v-if="index==0" class="primaryGColor text-white rounded p-2 shadow">
                    <p class="small">{{ item.year}}</p>
                    <h3>{{ item.result}}</h3>
                </div>
                <div v-else class="rounded p-2">
                    <p class="small">{{ item.year}}</p>
                    <h3>{{ item.result}}</h3>
                </div>

            </div>
        </b-card-body>
        <b-list-group flush>
            <b-list-group-item v-for="(item , index) in listdata" v-bind:key="index">{{ item.result }}
            </b-list-group-item>
        </b-list-group>
    </b-card>
</template>
<script>

export default {
  name: 'PersonYearResultCard',
  props: {
    listdata: Array,
    allyear: Array,
  },
  data () {
    return {}
  },
  methods: {}
}
</script>
